import { getRoleList, getServerList } from "@/api/account";
import { getParam } from "@/utils/";
import { language } from "@/language";
import { logout, getLoginPage, checkLogin, decryptUserInfo } from "@/api/account";
import { updateLinkParams, getGameId } from "@/utils";
import { SET_USERNAME,SET_UID,SET_LOGIN_STATE } from "./mutations";
export const INIT_SERVER_LIST = "INIT_SERVER_LIST";
export const INIT_ROLE_LIST = "INIT_ROLE_LIST";
export const SET_SERVER_INDEX = "SET_SERVER_INDEX";
export const SET_ROLE_INDEX = "SET_ROLE_INDEX";
export const LOGOUT = "LOGOUT";
export const JUMP_LOGIN = "JUMP_LOGIN";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const actions = {
  // 初始化服务器列表
  async [INIT_SERVER_LIST]({ state, commit, dispatch }) {
    if (state.serverList.length > 1) {
      return;
    }
    const res = await getServerList({
      id: window.id,
    });
    state.serverList = state.serverList.slice(0, 1).concat(res?.data || []);
    state.roleIndex = 0;
    let linkParam =
      getParam("serverId") || getParam("server_id") || getParam("serverID");
    for (let i in state.serverList) {
      if (state.serverList[i].id === linkParam) {
        state.serverIndex = +i;
        dispatch(SET_SERVER_INDEX, state.serverIndex);
        break;
      }
    }
  },
  // 初始化角色列表
  async [INIT_ROLE_LIST]({ state, commit }) {
    const res = await getRoleList({
      id: window.id,
      sid: state.serverList[state.serverIndex].sid,
    });
    state.roleIndex = 0;
    state.roleList = state.roleList.slice(0, 1).concat(res?.data || []);
    let linkParam =
      getParam("roleId") || getParam("role_id") || getParam("roleID");
    for (let i in state.roleList) {
      if (state.roleList[i].roleID === linkParam) {
        state.roleIndex = +i;
        break;
      }
    }
    state.roleList.length === 2 && (state.roleIndex = 1);
  },
  // 设置服务器索引
  async [SET_SERVER_INDEX]({ state, commit, dispatch }, serverIndex) {
    state.serverIndex = serverIndex;
    // 如果不为0，则重新更新角色列表
    if (serverIndex) {
      await dispatch(INIT_ROLE_LIST);
    }
  },
  // 登出
  async [LOGOUT]({ commit }) {
    try {
      const res = await logout();
      if (+res.result === 1) {
        window.location.reload();
      }
    } catch (error) {
      console.error("登出失败:", error);
    }
  },
  // 跳转登录页
  [JUMP_LOGIN]() {
    window.location.href = updateLinkParams(getLoginPage(), {
      gameId: getGameId(),
      forward: encodeURIComponent(
        window.globalGetGotoLink({ link: window.location.href })
      ),
    });
  },
  // 检查登录状态并设置用户信息
  async [CHECK_LOGIN]({ commit }) {
    try {
      const loginRes = await checkLogin();
      
      // 如果登录成功，设置用户信息
      if (+loginRes.result === 1 && loginRes.data) {
        const username = loginRes.data?.DISPLAY_NAME || loginRes.data?.LOGIN_ACCOUNT || "";
        commit(SET_USERNAME, username);
        commit(SET_LOGIN_STATE, true);
        return loginRes;
      }
      
      // 处理品牌问卷专属登录逻辑：通过 userInfo 参数解密用户信息
      const userInfo = getParam("userInfo");
      if (+loginRes.result !== 1 && userInfo) {
        try {
          const decryptRes = await decryptUserInfo(userInfo);
          if (+decryptRes.result === 1 && decryptRes.data) {
            commit(SET_USERNAME, decryptRes.data?.login_account);
            commit(SET_UID, decryptRes.data?.uid);
            commit(SET_LOGIN_STATE, true);
            return decryptRes;
          }
        } catch (error) {
          console.error("解密用户信息失败:", error);
        }
      }
      
      return loginRes;
    } catch (error) {
      console.error("检查登录状态失败:", error);
      throw error;
    }
  },
};
